// extracted by css-extract-rspack-plugin
export default {"locked":"AAKjhm","fixed":"GGbeXv","stretch":"gmLlZo"};